import Text from 'components/Text';
import React from 'react';
import styled from 'styled-components';
import { IcCalendar } from './assets/IcCalendar';
import { IcSms } from './assets/IcSms';
import { IcCallIn } from './assets/IcCallIn';
import { IcBooked } from './assets/IcBooked';
import { IcConfirm } from './assets/IcConfirm';
import { IcClose } from './assets/IcClose';
import { IcWaiting } from './assets/IcWaiting';
import { IcNoShow } from './assets/IcNoShow';
import { IcNewCus } from './assets/IcNewCus';
import { IcRegCus } from './assets/IcRegCus';
import { Row } from 'components/Box/Row';
import aptSelectors from 'services/selectors/apt';


interface ICallerIdSummary {
  label: string,
  value: number,
  icon: React.ReactNode 
}

const CallerIdSummary = () => {

  const summary = aptSelectors.getAppointmentSummaryCallerId();

  const config: ICallerIdSummary[] = [
    { label: 'SENT SMS', value: summary?.sendSmsCount ?? 0, icon: <IcSms/> },
    { label: 'CALL IN', value: summary?.totalCaller ?? 0, icon: <IcCallIn/> },
    { label: 'BOOKED', value: summary?.bookedCount ?? 0, icon: <IcBooked/> },
    // { label: 'CONFIRMED', value: 3, icon: <IcConfirm/> },
    // { label: 'WAITING', value: 4, icon: <IcWaiting/> },
    // { label: 'CANCELLED', value: 1, icon: <IcClose/> },
    // { label: 'NO SHOW', value: 2, icon: <IcNoShow/> },
    { label: 'NEW CUS.', value: summary?.newCustomerCount ?? 0, icon: <IcNewCus/> },
    { label: 'REGULAR CUS.', value: summary?.oldCustomerCount ?? 0, icon: <IcRegCus/> },
  ];

  return (
    <SummaryRow>
      {config.map((item, index) => (
        <SummaryCard key={index}>
          <Row alignItems='center' justifyContent='space-between'>
            {item.icon}
            <Text variant='H5'>
              {item.value}
            </Text>
          </Row>
          <Text variant='CONTENT_2' style={{color: '#4E5969', whiteSpace: 'nowrap'}}>
            {item.label}
          </Text>
        </SummaryCard>
      ))}
    </SummaryRow>
  );
};

export default CallerIdSummary;

const SummaryRow = styled.div`
  width: 100%;
  display: flex;
  gap: 12px;
  border-radius: 8px;
  background: #F6F7FC;
  box-shadow: 0px 4px 8px 0px #00000026;
  padding: 8px;
`;

const SummaryCard = styled.div`
  flex: 1;
  background: white;
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
`;